import { useState } from 'react';
import InputMask from "react-input-mask";
import './Cadastrar.css';


function Cadastrar() {
    const [nome, setNome] = useState("");
    const [email, setEmail] = useState("");
    const [telefone, setTelefone] = useState("");

    const validar = () => {
        if(nome === "") {
            alert("Por favor insira um Nome");
            return;
        }

        if(!email.includes("@") || !email.includes(".com") || email.length <=5) {
            alert("Por favor insira um E-mail válido.");
            return;
        }

        if(telefone.length !== 14) {
            console.log(telefone.length)
            alert("Por favor insira um telefone (com DDD) válido.");
            return;
        }

        window.location.href = `/obrigado?nome=${nome}&email=${email}&telefone=${telefone.replace('(', '').replace(')', '').replace('-', '').replace(' ', '')}`;
    }

    return (
        <div id="Cadastrar" className="CadastrarContainer">
            <div className="CadastrarText">
                Cadastre-se e seja um Sofier também
            </div>
            <div className="CadastrarInput">
                <input value={nome} placeholder="Nome*" onChange={(e) => setNome(e.target.value)} />
            </div>
            <div className="CadastrarInput">
                <input value={email} placeholder="E-mail*" onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div className="CadastrarInput">
                <InputMask 
                    type="tel" 
                    placeholder="Telefone*" 
                    onChange={(e) => setTelefone(e.target.value)}
                    mask="(99)99999-9999"
                    maskChar=" "
                />
            </div>
            <div className="CadastrarButton" onClick={() => validar()}>
                <div className="CadastrarButtonText">
                    Cadastrar
                </div>
            </div>
        </div>
    );
}

export default Cadastrar;